export enum UserStatusFilter {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING_DELETION = 'pending-deletion',
}
